<script>
import Vuex from 'vuex';

export default {
  data() {
    return {
      isActionPanelPopupIsOpen: false,
    };
  },

  computed: {
    isActionPanelOpen() {
      return this.$store.getters.getActionPanelOpenStatus;
    },
  },

  watch: {
    isActionPanelOpen(isOpen) {
      if (isOpen) {
        this.pauseVideo();
      }
    },
  },

  methods: Object.assign(
    {
      pauseVideo() {
        const video = this.$refs.video;
        if (video && !video.paused) {
          video.pause();
        }
      },

      onVideoPlay(num) {
        if (num) {
          this.hideActionPanel();
        }
        this.changePlayingStatus(true);
      },

      onVideoPause() {
        this.showActionPanel();
        this.changePlayingStatus(false);
      },

      onVideoEnd() {
        this.showActionPanel();
        this.changePlayingStatus(false);
      },

      changeActionPanelPopupStatus(isOpen) {
        this.isActionPanelPopupIsOpen = isOpen;
      },
    },
    Vuex.mapMutations([
      'showActionPanel',
      'hideActionPanel',
      'changePlayingStatus',
    ])
  ),
};
</script>
